import React, { useEffect, useState, useCallback } from "react";
import { Grid, Button, Box } from "@mui/material";
import { Helmet, PageTitle } from "@app/components/atoms";
import { useTranslation } from "react-i18next";
import { getTOUVersionMasterAll } from "@app/api";
import { LIMIT_PAGE } from "@app/constants";
import CreateTOUDialog from "./Components/CreateTOUDialog";
import ManageTOUTable from "./Components/ManageTOUTable";
import { IconPlus } from "@app/components/icons";

export function ManageTOU() {
  const { t } = useTranslation();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [touData, setTouData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [pageInfo, setPageInfo] = useState({
    page: 1,
    limit: LIMIT_PAGE,
    total: 0,
  });
  const [field, setField] = useState<string | undefined>(undefined);
  const [order, setOrder] = useState<string | undefined>(undefined);

  const fetchData = useCallback(
    async (params?: any) => {
      setLoading(true);
      try {
        const p = params ?? { limit: pageInfo.limit, page: pageInfo.page };
        const res = await getTOUVersionMasterAll(p);
        const data = res?.data?.data || [];
        setTouData(data);
        setPageInfo((prev) => res?.data?.meta?.pageInfo ?? { ...prev, ...p });
      } catch (err) {
        console.error("Error fetching TOU data", err);
        setTouData([]);
        setPageInfo((p) => ({ ...p, total: 0 }));
      } finally {
        setLoading(false);
      }
    },
    [pageInfo.limit, pageInfo.page]
  );

  useEffect(() => {
    fetchData({ limit: pageInfo.limit, page: pageInfo.page });
  }, [fetchData, pageInfo.page, pageInfo.limit, field, order]);

  const onCreateSuccess = async () => {
    setCreateDialogOpen(false);
    await fetchData();
  };

  return (
    <div className="group-list-page license">
      <Helmet title={t("metaInfo.manageTOU")} />

      <Box
        className="container"
        sx={{ mx: { xs: 2, sm: 3, md: 5, xl: "auto" }, px: "10px" }}
      >
        <Box sx={{ pt: 1, pb: 3, margin: "auto" }}>
          <PageTitle title={t("permission.MANAGE_TOU")} className="mt-0 mb-16" />

          <Grid container>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                variant="contained"
                className="btn-add-announcement"
                onClick={() => setCreateDialogOpen(true)}
              >
                <IconPlus />
                <span style={{ marginLeft: "8px" }}>{t("createTOU")}</span>
              </Button>
            </Grid>

            <Grid item xs={12} sx={{ mt: 3 }}>
              <ManageTOUTable
                touData={touData}
                loading={loading}
                field={field}
                setField={setField}
                order={order}
                setOrder={setOrder}
                getTOUs={fetchData}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
              />
            </Grid>
          </Grid>
        </Box>

        <CreateTOUDialog
          open={createDialogOpen}
          setOpen={setCreateDialogOpen}
          onSuccess={onCreateSuccess}
        />
      </Box>
    </div>
  );
}

export default ManageTOU;
